import { render, staticRenderFns } from "./WcCookieLaw.vue?vue&type=template&id=7fd95f81&lang=pug&"
import script from "./WcCookieLaw.vue?vue&type=script&lang=js&"
export * from "./WcCookieLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports